module.exports = __webpack_public_path__ + "media/images/payments/ripple-344186789bbe633957861d9a333a94ac.svg";